<template>
  <div>Conectando conta Microsoft...</div>
</template>

<script>
import { onMounted } from '@vue/composition-api'

export default {
  setup() {
    onMounted(() => {
      const params = new URLSearchParams(window.location.search)
      const authorizationCode = params.get('code')

      if (authorizationCode) {
        // 1. BroadcastChannel — entrega o código para qualquer aba/janela de mesma origem
        try {
          const bc = new BroadcastChannel('microsoft-oauth')
          bc.postMessage({ type: 'microsoft-auth-code', authorizationCode })
          bc.close()
        } catch (_) { /* browser sem suporte a BroadcastChannel */ }

        // 2. localStorage — fallback adicional
        localStorage.setItem('microsoft-auth-code', authorizationCode)

        // 3. Tenta fechar a janela (funciona para popups abertos com window.open,
        //    independente de window.opener ser null ou não)
        window.close()

        // 4. Se ainda estiver aberto após 800ms, é a aba principal (popup foi bloqueado)
        //    → redireciona de volta para a página de origem
        setTimeout(() => {
          if (!document.hidden) {
            const returnUrl = localStorage.getItem('microsoft-auth-return-url') || '/'
            localStorage.removeItem('microsoft-auth-return-url')
            window.location.href = returnUrl
          }
        }, 800)
      }
    })
  },
}
</script>
